import BOMMap from "./BOMMap";
import Device from "./Device";

export default class LicenseItem extends Device {
  constructor(json) {
    super(json);
    this.quantity = LicenseItem.getOrDefault(json, 'quantity', '');
  }

  extractReferences() {
    const bomMap = new BOMMap();
    bomMap.addReferencesToBOMMap(this.id, this.quantity);
    return bomMap;
  }
}
